import { useEffect, useState } from "react";
import useAxios from "../../../../Utils/useAxios";
import FeatureContainer from "../../../../Layout/Containers/FeatureContainer";
import PengaturanModal from "../../../../Layout/Components/PengaturanModal";
import PengaturanListLayout from "../../../../Layout/Components/PengaturanListLayout";
import { Button, Form } from "reactstrap";
import { Controller, useForm } from "react-hook-form";
import { InputField } from "../../../../CommonElements";
import CreateButton from "../../../../CommonElements/Button/CreateButton";
import EditButton from "../../../../CommonElements/Button/EditButton";
import ActiveButton from "../../../../CommonElements/Button/ActiveButton";
import DataTableTitle from "../../../DataTableComponents/DataTableTitle";
import FooterList from "../components/FooterList";
import FooterModal from "../components/FooterModal";
import getFooter from "../services/getFooter";

// Main Container
const PengaturanSlipGajiContain = () => {
  const [footers, setFooters] = useState([]);
  const [pending, setPending] = useState(true);
  const axiosInstance = useAxios();

  const fetchFooters = async () => {
    setPending(true);
    getFooter(axiosInstance).then((res) => {
      setFooters(res.data);
      setPending(false);
    })
  };

  useEffect(() => {
    fetchFooters();
  }, []);

  return (
    <FeatureContainer
      createButton={<FooterModal create={true} resetState={fetchFooters} />}
      type="pengaturan"
    >
      <FooterList items={footers} resetState={fetchFooters} pending={pending} />
    </FeatureContainer>
  );
};

export default PengaturanSlipGajiContain;
